/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileKeynote32 = (props: SVGProps) => (
    <AccessibleSVG width={32} height={32} viewBox="0 0 32 32" {...props}>
        <path
            d="M9 3h9.586a1 1 0 01.707.293l6.415 6.414a1 1 0 01.293.707V26A3 3 0 0123 29H9a3 3 0 01-3-3V6a3 3 0 013-3z"
            fill="#1A66EF"
        />
        <path
            d="M19.286 3.286l5.01 5.009 1.412 1.412a1 1 0 01.203.293H21a2 2 0 01-2-2V3.09a1 1 0 01.286.196z"
            fill="#fff"
            fillOpacity={0.5}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.991 16.925l-.697-4.338a.697.697 0 00-.688-.587h-8.212a.697.697 0 00-.688.587l-.697 4.338a.698.698 0 00.688.807h9.606a.698.698 0 00.688-.807zM17.979 24.225h-2.092V18.2h-.774v6.025H13.02c-.31 0-.465.155-.465.387 0 .233.155.388.465.388h4.958c.31 0 .465-.155.465-.387 0-.233-.155-.388-.465-.388z"
            fill="#fff"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5 14.169l-1.047 1.253c.294.186.656.296 1.047.296.391 0 .753-.11 1.047-.296.301-.19.53-.46.648-.774l-1.695-.479z"
            fill="#66C155"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.805 14.648a1.365 1.365 0 010-.958l1.695.479-1.695.479z"
            fill="#FA9E27"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.453 12.916a1.958 1.958 0 011.047-.296v1.549l-1.047-1.253z"
            fill="#AB4287"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.195 13.69a1.584 1.584 0 00-.648-.774 1.957 1.957 0 00-1.047-.296v1.549l1.695.479a1.365 1.365 0 000-.958z"
            fill="#61D9FE"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.453 15.422c-.301-.19-.53-.46-.648-.774l1.695-.479-1.047 1.253z"
            fill="#FBCE5A"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.805 13.69c.117-.314.347-.584.648-.774l1.047 1.253-1.695-.479z"
            fill="#E85A5E"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.311 16.338H11.69c-.248 0-.372.124-.372.31s.124.31.372.31h7.622c.248 0 .372-.124.372-.31s-.124-.31-.372-.31z"
            fill="#C7E8FD"
        />
    </AccessibleSVG>
);

export default FileKeynote32;
